import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import _ from 'lodash';

@Component({
   selector: 'samweb-clear-button',
   templateUrl: './clear-button.component.html',
   styleUrls: ['./clear-button.component.scss'],
})
export class ClearButtonComponent implements OnInit {
   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   @Input()
   public toolTipText: string;

   @Output()
   public click = new EventEmitter();

   constructor() {}

   ngOnInit(): void {
      if (_.isNil(this.toolTipText)) {
         this.toolTipText = '';
      }
   }

   onButtonClick(event) {
      // NOTE: prevent parent firing this component click event again.
      event.stopPropagation();
      this.click.emit();
   }
}
